export const exclusionOperators = [
    { label: 'Contains the text', value: 'contains_the_text' },
    // { label: 'Equals', value: 'is_equal' },
];
